import { Card, styled, Typography } from '@mui/material';

import { Colors } from 'Themes/colors';
import { Spacing } from 'Themes/spacing';

export const StyledCard = styled(Card)<{ isClickable?: boolean }>`
  position: relative;
  display: grid;
  grid-template-columns: 0.6fr 2fr 2fr 1fr;
  gap: ${Spacing.medium};
  align-items: center;
  border: 1px solid ${Colors.lineGrey};
  border-radius: 8px;
  padding: ${Spacing.medium} ${Spacing.large};
  width: 100%;
  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'default')};
  transition: box-shadow 0.2s ease-in-out;

  ${({ isClickable }) =>
    isClickable &&
    `
      &:hover {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      }
    `}
`;

export const ColumnContent = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const TitleText = styled(Typography)`
  font-weight: 600;
`;

export const DateText = styled(Typography)`
  color: ${Colors.darkGrey};
  min-width: 200px;
`;
